import { ZoneSaturationLevelType } from '~globals/types/enums';
import { DashboardZoneSaturationZone } from '~services/dashboard/types';
import { pluralize } from '~utils/commons';

import { getZoneSaturationLevelColor } from '../../../../../utils';

export type ZoneSaturationLevelParams = Pick<
  DashboardZoneSaturationZone,
  'saturationLevelTypeId' | 'availableCapacity' | 'overCapacity'
>;

export interface ZoneSaturationLevelConfig {
  color: string;
  actionLabel: string;
  actionDescription: string;
}

export const ZONE_SATURATION_LEVEL_CONFIG: Record<
  ZoneSaturationLevelType,
  (
    params: Omit<ZoneSaturationLevelParams, 'saturationLevelTypeId'>,
  ) => ZoneSaturationLevelConfig
> = {
  [ZoneSaturationLevelType.WithMargin]: ({ availableCapacity }) => ({
    color: getZoneSaturationLevelColor(ZoneSaturationLevelType.WithMargin),
    actionLabel: 'Capacidad disponible',
    actionDescription: pluralize({
      singular: 'paquete libre',
      plural: 'paquetes libres',
      count: availableCapacity,
      includeCount: true,
    }),
  }),
  [ZoneSaturationLevelType.OnAlert]: ({ availableCapacity }) => ({
    color: getZoneSaturationLevelColor(ZoneSaturationLevelType.OnAlert),
    actionLabel: 'Monitorear saturación',
    actionDescription: pluralize({
      singular: 'paquete de margen',
      plural: 'paquetes de margen',
      count: availableCapacity,
      includeCount: true,
    }),
  }),
  [ZoneSaturationLevelType.Saturated]: ({ overCapacity }) => ({
    color: getZoneSaturationLevelColor(ZoneSaturationLevelType.Saturated),
    actionLabel: 'Sumar chofer de distribución',
    actionDescription: pluralize({
      singular: 'paquete sobre la capacidad',
      plural: 'paquetes sobre la capacidad',
      count: overCapacity,
      includeCount: true,
    }),
  }),
};

export const getZoneSaturationLevelConfig = ({
  saturationLevelTypeId,
  availableCapacity,
  overCapacity,
}: ZoneSaturationLevelParams): ZoneSaturationLevelConfig => {
  const currentZoneSaturationLevelConfig =
    ZONE_SATURATION_LEVEL_CONFIG[saturationLevelTypeId] ??
    ZONE_SATURATION_LEVEL_CONFIG[ZoneSaturationLevelType.WithMargin];

  return currentZoneSaturationLevelConfig({ availableCapacity, overCapacity });
};
